<div class="lp-on-trigger-canvas-component" style="width: 100%; height: 100%"></div>
